// removed by extract-text-webpack-plugin
module.exports = {"wrapper-select-filter":"magazines_1M71H","opened":"magazines_cBUBK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Select/styles.scss
// module id = 1127
// module chunks = 1